import React from "react";
import compose from "lodash/fp/compose";
import { connect } from "react-redux";
import hoistNonReactStatics from "hoist-non-react-statics";
import { getIndustryType } from "actions/preload";
import { BaseHOC, withBaseHOCProps } from "../common/BaseHOC";

let loaded = false

export const withIndustryType = (WrappedComponent) => {
  class IndustryType extends BaseHOC {

    async componentDidMount() {
      const { getIndustryType } = this.props
      if (!loaded)  {
        loaded = true;
        await getIndustryType();
      }
    }

    get industryTypeOptions() {
      const { industryType } = this.props;
      return this._getOptions(industryType, ['id'], true)
    }

    render() {
      return (
        <WrappedComponent 
          {...this.props} 
          industryTypeOptions={this.industryTypeOptions}
        />
      )
    }
  }
  const mapStateToProps = ({ industryType }) => ({ industryType })
  const WithIndustryType = connect(mapStateToProps, { getIndustryType })(IndustryType);
  hoistNonReactStatics(WithIndustryType, WrappedComponent)
  return compose(withBaseHOCProps)(WithIndustryType);
}
